<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p3_natanz-box">
  <!-- Artboard: xs -->
  <div
    id="g-p3_natanz-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.76036866359447;"
  >
    <div
      id="g-p3_natanz-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_natanz-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.862%;margin-top:-11.1px;left:0.1515%;width:159px;"
    >
      <p class="g-pstyle0">Natanz nuclear facility</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:13.7092%;margin-top:-7.5px;left:10.9783%;width:58px;"
    >
      <p class="g-pstyle1">Natanz</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:17.1654%;margin-top:-7.5px;left:16.2673%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:24.8152%;margin-top:-14.7px;left:35.483%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle3">Facilities</p>
      <p class="g-pstyle3">damaged</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p3_natanz-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.80824088748019;"
  >
    <div
      id="g-p3_natanz-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_natanz-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.4523%;margin-top:-11.2px;left:0.098%;width:178px;"
    >
      <p class="g-pstyle0">Natanz nuclear facility</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:9.9046%;margin-top:-7.5px;left:9.2037%;width:58px;"
    >
      <p class="g-pstyle1">Natanz</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:12.7572%;margin-top:-7.5px;left:13.1629%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:20.5544%;margin-top:-14.7px;left:24.8629%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle3">Facilities</p>
      <p class="g-pstyle3">damaged</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p3_natanz-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.79613992762364;"
  >
    <div
      id="g-p3_natanz-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_natanz-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.3667%;margin-top:-11.3px;left:0.0758%;width:217px;"
    >
      <p class="g-pstyle0">Natanz nuclear facility</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:10.7456%;margin-top:-9.1px;left:9.9195%;width:64px;"
    >
      <p class="g-pstyle1">Natanz</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:13.0375%;margin-top:-9.1px;left:12.6798%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:21.3146%;margin-top:-14.7px;left:24.8948%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle3">Facilities</p>
      <p class="g-pstyle3">damaged</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-18 21:08 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-18 21:08 -->
<!-- ai file: p3_natanz.ai -->
<style lang="scss">
  #g-p3_natanz-box,
  #g-p3_natanz-box .g-artboard {
    margin: 0 auto;
  }
  #g-p3_natanz-box p {
    margin: 0;
  }
  #g-p3_natanz-box .g-aiAbs {
    position: absolute;
  }
  #g-p3_natanz-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p3_natanz-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p3_natanz-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p3_natanz-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p3_natanz-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) {
      #g-p3_natanz-md {
        display: block !important;
      }
    }
  }
  #g-p3_natanz-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p3_natanz-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_natanz-xs .g-pstyle0 {
    height: 21px;
  }
  #g-p3_natanz-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p3_natanz-xs .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_natanz-xs .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p3_natanz-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p3_natanz-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_natanz-sm .g-pstyle0 {
    height: 21px;
  }
  #g-p3_natanz-sm .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p3_natanz-sm .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_natanz-sm .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p3_natanz-md {
    position: relative;
    overflow: hidden;
  }
  #g-p3_natanz-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 20px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_natanz-md .g-pstyle0 {
    height: 21px;
  }
  #g-p3_natanz-md .g-pstyle1 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-p3_natanz-md .g-pstyle2 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0.2em;
    font-size: 14px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_natanz-md .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
    color: rgb(255, 255, 255);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
